<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLiveStreamCloud_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2.333 11.667h9.606q.175 0 .34.004c.61.012 1.142.022 1.72-.338.426-.264.668-1.562.668-2.291q0-1.006-.69-1.758a2.68 2.68 0 0 0-1.735-.867q0-1.707-1.235-2.895Q9.774 2.334 8 2.333q-1.44 0-2.576.832A3.96 3.96 0 0 0 3.91 5.338a3.17 3.17 0 0 0-1.864 1.137 3.16 3.16 0 0 0-.712 2.027c0 .885.667 3.165 1 3.165m7.667-4-3.333-2v4z"
        clip-rule="evenodd"
    />
</svg>
